const numberOfEmployees = [
  { label: '0-5', value: 'BETWEEN_0_AND_5' },
  { label: '6-10', value: 'BETWEEN_6_AND_10' },
  { label: '11-50', value: 'BETWEEN_11_AND_50' },
  { label: '51-100', value: 'BETWEEN_51_AND_100' },
  { label: '>100', value: 'MORE_THAN_100' }
]

export default numberOfEmployees
